<template>
	<div class="container" v-if="get_products.length > 0">
		<div class="sec-maker-header text-center">
			<h3 class="sec-maker-h3">Related Products</h3>
		</div>
		<div class="wrapper-content">
			<div class="outer-area-tab">
				<div class="tab-content">
					<!-- BEST SELLER PRODUCTS -->
					<div class="tab-pane active show fade" id="men-latest-products">
						<div class="row">
							<div
								class="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
								v-for="product in get_products"
								:key="product.id"
								@click="handleRedirect(product)"
							>
								<!-- <pre>{{products_data[0].category.name}}</pre> -->
								<div class="card" style="height: 100%">
									<div class="card-body related_product_card">
										<h5 class="card-title font-weight-bold">{{ product.product.product_name }}</h5>
										<img
											class="img-fluid"
											height="100"
											v-lazy="{
												src: getImage(product.product.lowest_price_image.path),
												loading: publicPath + 'assets/images/spinner.gif',
												error: publicPath + 'assets/images/not_found.png',
											}"
										/>
										<div>
											{{ formatCurrency(product.product.lowest_price) }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {formatCurrency} from "../../../../utils/common_functions";
	import {publicPath} from "../../../../../vue.config";
	export default {
		props: ["products"],
		computed: {
			get_products() {
				let key = Object.keys(this.products || []);
				let products = [];
				for (let i in key) {
					products.push(this.products[key[i]]);
				}
				return products;
			},
		},
		data() {
			return {
				publicPath: publicPath,
			};
		},

		methods: {
			formatCurrency,
			getImage(path) {
				return process.env.VUE_APP_API_URL + path;
			},
			handleRedirect(product) {
				this.$router.push({
					name: "ProductDetail",
					params: {id: product.id, slug: product.product.product_slug},
				});
			},
		},
	};
</script>

<style scoped>
	.related_product_card {
		cursor: pointer;
	}
	.related_product_card:hover {
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
		transition: ease-in-out 0.3s;
	}
</style>
